@if (showCaption()) {
  <span class="content" @captionAnimation [@.disabled]="!withAnimation()">
    <ng-content />
  </span>
}

@if (icon(); as icon) {
  <span class="icon" [class]="icon"></span>
}
